import { isMockServices } from 'src/utils';
import mock from 'src/services/utils/mock';
import { MutationFunction } from '@tanstack/react-query';
import { getCompatibleAuthTokenHttp } from '../utils/enhancedAuthTokenHttp';

export interface UploadLOConfigurationParams {
  file: File;
}

export interface UploadLOConfigurationResponse {
  success: boolean;
  message: string;
}

const uploadLOConfiguration: MutationFunction<
  UploadLOConfigurationResponse,
  UploadLOConfigurationParams
> = async (args) => {
  if (isMockServices())
    return await mock(_mockUploadLOConfiguration, { delay: 2000 });

  const formData = new FormData();
  formData.append('file', args.file);
  const authTokenHttp = await getCompatibleAuthTokenHttp();
  const response = await authTokenHttp<UploadLOConfigurationResponse>(
    `/seed/encompass/loan-ingestion-fields`,
    {
      method: 'POST',
      body: formData,
    },
  );
  if (response.data) return response.data;
  throw new Error('Failed to upload mappings');
};

export default uploadLOConfiguration;

// Mock data for development
const _mockUploadLOConfiguration: UploadLOConfigurationResponse = {
  success: true,
  message: 'Loan Originator configuration uploaded successfully',
};
